import {
  FETCH_CHAPTER_DATA,
  FETCH_CHAPTER_DATA_CONTENT,
  FETCH_CHAPTER_DATA_CONTENT_ALT,
  FETCH_CHAPTER_DATA_ROW,
  FETCH_CHAPTER_DATA_TYPO,
  FETCH_CHAPTER_DATA_ERROR,
  FETCH_CHAPTER_DATA_LOADING,
} from "../constants";
import { CardUINavbarCard } from "./CardUIActions";
import { setExpandAll, setLineSpacing, escapeQuotes } from "../functionUtils";
import gql from "graphql-tag";
import client from "../apolloClient";

export function chapterDataFetchData(
  fetchQuery = null,
  limit = 100,
  page = 1,
  idProject,
  content = false
) {
  return (dispatch, getState) => {
    dispatch(chapterDataIsLoading(true));
    let query;

    if (fetchQuery) {
      query = fetchQuery;
    } else {
      query = gql`
        {
          simcaa_t_projects_chapt(where: { caa_project_id: { _eq: ${idProject} } }, order_by: {id: desc}) {
            id
            chapt_title
            chapt_user_block
            content {
              caa_chapt_id
            }
            content_alt {
              caa_chapt_id
            }
            row {
              caa_chapt_id
            }
            typo {
              caa_chapt_id
            }
            updated_at
          }
        }
      `;
    }
    client
      .query({ query })
      .then((data) => {
        dispatch(chapterDataIsLoading(false));
        if (data.networkStatus !== 7) {
          dispatch(chapterDataHasErrored(true));
        } else {
          let initialRowsArray = [{ times: 1, type: "none", row: 0 }];
          if (content) {
            let chapt = data.data.simcaa_t_projects_chapt[0];
            // let chapt_content = chapt.content[0].chapt_content
            // chapt_content = chapt_content ? chapt_content.replace('"""', '"\\\""') : null;
            // let content_alt = chapt.content_alt[0].chapt_image_alt
            // let contentData = !chapt_content ? "" : JSON.parse(chapt_content);
            // contentData = contentData ? contentData.map(item => {
            //   item.lemma === '\\"' ? "\"" : item.lemma
            //   return item
            // }) : ""
            // let contentAltData = !content_alt ? "" : JSON.parse(content_alt);
            // let rowData = !chapt_content ? initialRowsArray : JSON.parse(chapt.row[0].chapt_row)

            let chapt_content = chapt.content[0].chapt_content;
            let content_alt = chapt.content_alt[0].chapt_image_alt;
            let contentData = !chapt_content ? "" : chapt_content;
            let contentAltData = !content_alt ? "" : content_alt;
            let rowData = !chapt_content
              ? initialRowsArray
              : chapt.row[0].chapt_row;

            if (
              Object.keys(contentData).length !== 0 &&
              typeof contentData === "object"
            ) {
              dispatch(chapterContentDataFetchDataSuccess(contentData));
              dispatch(chapterContentAltDataFetchDataSuccess(contentAltData));
              dispatch(chapterRowsDataFetchDataSuccess(rowData));

              setTimeout(() => {
                dispatch(CardUINavbarCard(0));

                let indexProject = getState().projectData.findIndex(
                  (x) => x.proj_id === getState().selectedProjectID
                );
                let margins = JSON.parse(
                  getState().projectData[indexProject].proj_profile
                ).layout.layout_margins;
                setLineSpacing(margins);

                setExpandAll(getState().chapterContentData.slice());
              }, 0);
            } else {
              contentData = [
                {
                  id: 0,
                  lemma: "simcaa",
                  lemmaPrevious: "simcaa",
                  img: "simcaa.png",
                  sinonimi: 0,
                  lock: "unlock",
                  codClass: "Altro",
                  complex: "0",
                  row: 0,
                  voice_master: "simcaa",
                },
              ];
              contentAltData = [
                {
                  voice_human: "simcaa",
                  voice_master: "simcaa",
                  img: "simcaa.png",
                },
              ];
              dispatch(chapterContentDataFetchDataSuccess(contentData));
              dispatch(chapterContentAltDataFetchDataSuccess(contentAltData));
              dispatch(chapterRowsDataFetchDataSuccess(initialRowsArray));
            }
            let typo = chapt.typo[0];
            if (typo.chapt_typo_card) {
              // const chapt_typo_card = JSON.parse(typo.chapt_typo_card.replace('"""', '"\\\""'));
              // const chapt_typo_imgex = JSON.parse(typo.chapt_typo_imgex);
              // const chapt_typo_text = JSON.parse(typo.chapt_typo_text.replace(/\n/g, "\\n"))
              // const chapt_typo_draw = JSON.parse(typo.chapt_typo_draw);
              // const options = {
              //   pagesNumber: JSON.parse(typo.chapt_typo_profile).pagesNumber,
              //   imgSize: JSON.parse(typo.chapt_typo_profile).imgSize,
              // };
              const chapt_typo_card = typo.chapt_typo_card;
              const chapt_typo_imgex = typo.chapt_typo_imgex;
              const chapt_typo_text = typo.chapt_typo_text;
              const chapt_typo_draw = typo.chapt_typo_draw;
              const options = {
                pagesNumber: typo.chapt_typo_profile.pagesNumber,
                imgSize: typo.chapt_typo_profile.imgSize,
              };

              const typoData = {
                card: chapt_typo_card,
                img: chapt_typo_imgex,
                text: chapt_typo_text,
                shapes: chapt_typo_draw,
                pagesNumber: options.pagesNumber,
                imgSize: options.imgSize,
              };

              dispatch(chapterTypoDataFetchDataSuccess(typoData));
            }
          } else {
            let chapts = data.data.simcaa_t_projects_chapt.slice();
            chapts = chapts.map((item) => {
              item.contentId =
                item.content.length > 0 ? item.content[0].caa_chapt_id : 0;
              item.typoId =
                item.typo.length > 0 ? item.typo[0].caa_chapt_id : 0;
              item.rowId = item.row.length > 0 ? item.row[0].caa_chapt_id : 0;
              item.contentAltId =
                item.content_alt.length > 0
                  ? item.content_alt[0].caa_chapt_id
                  : 0;
              delete item.content;
              delete item.typo;
              delete item.row;
              delete item.__typename;
              return item;
            });
            dispatch(chapterDataFetchDataSuccess(chapts));
          }

          dispatch(chapterDataHasErrored(false));
        }
      })
      .catch((error) => {
        dispatch(chapterDataIsLoading(false));
        dispatch(chapterDataHasErrored(false));
      });
  };
}

export function chapterDataCreateData(mutationQuery, data = {}, projectId) {
  return (dispatch) => {
    dispatch(chapterDataIsLoading(true));

    client
      .mutate({ mutation: mutationQuery, variables: { objects: [data] } })
      .then((data) => {
        dispatch(chapterDataIsLoading(false));
        if (data.data) {
          dispatch(chapterDataHasErrored(false));
          dispatch(chapterDataFetchData(null, 30, 1, projectId));
        } else {
          dispatch(chapterDataHasErrored(true));
        }
      })
      .catch((error) => {
        dispatch(chapterDataIsLoading(false));
        dispatch(chapterDataHasErrored(true));
      });
  };
}

export function chapterDataUpdateData(
  mutationQuery,
  variables = {},
  projectId = null
) {
  return (dispatch) => {
    dispatch(chapterDataIsLoading(true));

    client
      .mutate({ mutation: mutationQuery, variables })
      .then((data) => {
        dispatch(chapterDataIsLoading(false));
        if (data.data) {
          dispatch(chapterDataHasErrored(false));
          if (projectId) {
            dispatch(chapterDataFetchData(null, 30, 1, projectId));
          }
        } else {
          dispatch(chapterDataHasErrored(true));
        }
      })
      .catch((error) => {
        dispatch(chapterDataIsLoading(false));
        dispatch(chapterDataHasErrored(true));
      });
  };
}

export function chapterDataDeleteData(id, projectId) {
  return (dispatch) => {
    dispatch(chapterDataIsLoading(true));

    let query = gql`
      mutation deleteChapter {
        delete_simcaa_t_projects_chapt(where: {id: {_eq: ${id}}}) {
          affected_rows
        }
      }
    `;

    client
      .mutate({ mutation: query })
      .then((data) => {
        dispatch(chapterDataIsLoading(false));
        if (data.data) {
          dispatch(chapterDataHasErrored(false));
          dispatch(chapterDataFetchData(null, 30, 1, projectId));
        } else {
          dispatch(chapterDataHasErrored(true));
        }
      })
      .catch((error) => {
        dispatch(chapterDataIsLoading(false));
        dispatch(chapterDataHasErrored(true));
      });
  };
}

export function duplicateChapter(chapter_id) {
  return (dispatch) => {
    // const query = gql`
    //   {
    //     simcaa_t_projects_chapt(where: {id: {_eq: ${chapter_id}}}) {
    //       id
    //       chapt_content
    //       chapt_row
    //       chapt_title
    //       chapt_typo
    //       caa_project_id
    //     }
    //   }
    // `;
    const query = gql`
    {
      simcaa_t_projects_chapt(where: {id: {_eq: ${chapter_id}}}) {
        id
        chapt_title
        caa_project_id
        typo {
          chapt_typo_card
          chapt_typo_imgex
          chapt_typo_text
          chapt_typo_draw
          chapt_typo_profile
        }
        content {
          chapt_content
        }
        row {
          chapt_row
        }
        content_alt {
          chapt_image_alt
        }
      }
    }
  `;

    client.query({ query }).then((data) => {
      const chapt = data.data.simcaa_t_projects_chapt[0];
      delete chapt.typo[0].__typename;
      delete chapt.content[0].__typename;
      delete chapt.content_alt[0].__typename;
      delete chapt.row[0].__typename;
      const newData = {
        caa_project_id: chapt.caa_project_id,
        chapt_title: `copia_di_${chapt.chapt_title}`,
        // chapt_content: chapt.chapt_content,
        // chapt_row: chapt.chapt_row,
        // chapt_typo: chapt.chapt_typo,
        chapt_user_block: 0,
        typo: { data: chapt.typo[0] },
        content: { data: chapt.content[0] },
        row: { data: chapt.row[0] },
        content_alt: { data: chapt.content_alt[0] },
      };

      const mutation = gql`
        mutation duplicateChapter(
          $objects: [simcaa_t_projects_chapt_insert_input!]!
        ) {
          insert_simcaa_t_projects_chapt(objects: $objects) {
            affected_rows
          }
        }
      `;
      dispatch(chapterDataCreateData(mutation, newData, chapt.caa_project_id));
    });
  };
}

export function chapterDataHasErrored(bool) {
  return {
    type: FETCH_CHAPTER_DATA_ERROR,
    hasErrored: bool,
  };
}

export function chapterDataIsLoading(bool) {
  return {
    type: FETCH_CHAPTER_DATA_LOADING,
    isLoading: bool,
  };
}

export function chapterDataFetchDataSuccess(chapter) {
  return {
    type: FETCH_CHAPTER_DATA,
    chapter,
  };
}

export function chapterContentDataFetchDataSuccess(content) {
  return {
    type: FETCH_CHAPTER_DATA_CONTENT,
    content,
  };
}

export function chapterContentAltDataFetchDataSuccess(content_alt) {
  return {
    type: FETCH_CHAPTER_DATA_CONTENT_ALT,
    content_alt,
  };
}

export function chapterRowsDataFetchDataSuccess(rows) {
  return {
    type: FETCH_CHAPTER_DATA_ROW,
    rows,
  };
}

export function chapterTypoDataFetchDataSuccess(typo) {
  return {
    type: FETCH_CHAPTER_DATA_TYPO,
    typo,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/ChapterFetchActions.js